import { render, staticRenderFns } from "./YoungChat.vue?vue&type=template&id=9f4dea5e&scoped=true&"
import script from "./YoungChat.vue?vue&type=script&lang=js&"
export * from "./YoungChat.vue?vue&type=script&lang=js&"
import style0 from "./YoungChat.vue?vue&type=style&index=0&id=9f4dea5e&prod&scoped=true&lang=css&"
import style1 from "./YoungChat.vue?vue&type=style&index=1&id=9f4dea5e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4dea5e",
  null
  
)

export default component.exports